// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://wclavdorghsnatwesziv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndjbGF2ZG9yZ2hzbmF0d2Vzeml2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ3MzUwNzIsImV4cCI6MjA3MDMxMTA3Mn0.pjBK02Mtx74RmdJKfnABMjeCojeOexhMXm3UVOj6lLk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});